<div class="overlay-form" #reviewInfo>
  <div class="header-content">
    @if (averagerating) {
    <div class="customer-review-detail">
      <div class="google-logo-wrapper">
        <img
          src="https://s3.ap-south-1.amazonaws.com/assets.hyperinvento.com/hyperinventory_admin/dynamic-home-assets/common/google-logo.svg"
          alt="Google"
          class="google-summary-icon"
        />
      </div>
      <div class="google-rating-info">
        <div class="google-rating-score">{{ averagerating }}</div>
        <webstore-star-rating [rating]="averagerating"></webstore-star-rating>
        <div
          (click)="openGoogleReviewPage()"
          class="google-review-count"
          [ngClass]="{ 'url-style-handle': isUrlAvailable }"
        >
          {{ totalreviewcount }} Google reviews
        </div>
      </div>
    </div>
    }
    <img (click)="ref.close()" [src]="IMAGE_URLS.closeIconDark" class="close-icon" />
  </div>
  <div class="overlay-content" id="line-clamp-disable">
    <div class="form-content">
      <section class="review-layout-overlay">
        <div class="review-layout-list">
          <div class="listing-container">
            <div class="inner-container">
              <div class="review-block">
                <div
                  (click)="openGoogleReviewPage()"
                  class="h-100"
                  [innerHTML]="baseHtml | reviewInterpolation : review | safeHtml"
                ></div>
              </div>
              <div class="all-reviews-container">
                <p class="more-reviews-title">More Reviews</p>
                @for (review of reviews; track review.id) {
                <div class="review-block">
                  <div
                    class="h-100"
                    [innerHTML]="baseHtml | reviewInterpolation : review | safeHtml"
                  ></div>
                </div>
                }
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
